import React, { useContext, useEffect, useState } from "react";
import {
    Label,
    Wrapper,
    SingleValueWrapper,
    OptionWrapper,
} from "./styled.js";
import SelectAsync from 'react-select/lib/Async';
import { fetchVendors } from "./service";
import { AppContext } from "hocs/withAppContext";

const SingleValue = ({ innerProps, innerRef, data }) =>
    <SingleValueWrapper ref={innerRef} {...innerProps}>
        {data.businessName}
    </SingleValueWrapper>;

const Option = ({ innerProps, innerRef, data }) =>
    <OptionWrapper ref={innerRef} {...innerProps}>
        <p>{data.businessName}</p>
        {data.vendorType && <p>{data.vendorType}</p>}
    </OptionWrapper>;

export const SelectVendor = ({ label, placeholder, required,
                                 value = '', onChange, error }) => {
    const { role } = useContext(AppContext);
    const roleId = role.objectId;

    const [defaultOptions, setDefaultOptions] = useState([]);
    useEffect(() => {
        fetchVendors(roleId).then(setDefaultOptions);
    }, [roleId]);

    return <Wrapper className="select-box">
        {label && <Label required={required}>{label}</Label>}
        <SelectAsync
            className={ error ? 'data-error': ''}
            classNamePrefix="react-select"
            placeholder={placeholder}
            required={required}
            defaultOptions={defaultOptions}
            loadOptions={q => fetchVendors(roleId, q)}
            components={{ SingleValue, Option }}
            isClearable={true}
            value={value}
            onChange={onChange}
        />
    </Wrapper>
};

export default SelectVendor;
